// eslint-disable-next-line import/no-cycle
import Hero from './Hero.component';

export default Hero;
